import * as React from "react";
import { SVGProps } from "react";

const TickIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" fill="none" {...props}>
    <rect width={12} height={12} fill={props.color} rx={6} />
    <path stroke="#fff" strokeWidth={1.2} d="m4 6.287 1.143 1.142L8 4.572" />
  </svg>
);
export default TickIcon;
